// @flow

import type { State } from './reducers';
import type { ReviewItem } from '../../types';

type GlobalState = {
  review: State,
};

const getReducer = (state: GlobalState): State => state.review;

export const getReviewItems = (state: GlobalState): Array<ReviewItem> => getReducer(state).items;

export const getReviewFormLinkUrl = (state: GlobalState): string => getReducer(state).formLinkUrl;

export const getReviewFormLinkText = (state: GlobalState): string => getReducer(state).formLinkText;

export default null;
